<template>
    <div
        v-if="formattedDate || (news.author)"
        class="news-meta"
    >
        <template v-if="formattedDate">
            {{ formattedDate }}
        </template>
        <template
            v-if="formattedDate && news.author"
        >
            &bullet;
        </template>
        <template v-if="news.author">
            {{ news.author }}
        </template>
    </div>
</template>

<script setup>
const props = defineProps({
    news: {
        type: Object,
        required: true,
        default: null
    }
});

const formattedDate = computed(() => {
    if (props.news.postDate) {
        return `${useDate().formatSingleDate(props.news.postDate, useDate().formats.dayMonthYear)}`;
    } else {
        return null;
    }
});
</script>

<style lang="less">
.news-meta {
    margin: 1.5rem 0;
    font-size: var(--font-size-sm);
}
</style>
